// Imports
import axios from "axios";
import { rutas } from "../../routes_backend/routes.jsx";

export const GET_PLANTAS_REQUEST = "GET_PLANTAS_REQUEST";
export const GET_PLANTAS_RESPONSE = "GET_PLANTAS_RESPONSE";
export const GET_PLANTAS_FAILURE = "GET_PLANTAS_FAILURE";

export function getPlantas() {
  let url = rutas.get_plantas;
  return (dispatch) => {
    dispatch({
      type: GET_PLANTAS_REQUEST,
    });
    return axios
      .get(url)
      .then(async (response) => {
        const res = await response.data;
        let temp = [];

        res.sort(function (a, b) {
          if (a.Code > b.Code) {
            return 1;
          }
          if (a.Code < b.Code) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
        res.forEach((element) => {
          if (element.Code.length > 2) {
            temp.push(element);
          }
        });
        var planta = temp.filter((item) => {
          return (
            item.Code.trim() !== "PERFILES" && item.Code.trim() !== "BODEGA" && item.Code.trim() !== "IMPORTACION"
          );
        });
        dispatch({
          type: GET_PLANTAS_RESPONSE,
          get_plantas: planta,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_PLANTAS_FAILURE,
        });
      });
  };
}

export const GET_FAMILIA_PLANTAS_REQUEST = "GET_FAMILIA_PLANTAS_REQUEST";
export const GET_FAMILIA_PLANTAS_RESPONSE = "GET_FAMILIA_PLANTAS_RESPONSE";
export const GET_FAMILIA_PLANTAS_FAILURE = "GET_FAMILIA_PLANTAS_FAILURE";

export function getFamiliaPlantas() {
  let url = rutas.get_familia;
  return (dispatch) => {
    dispatch({
      type: GET_FAMILIA_PLANTAS_REQUEST,
    });
    return axios
      .get(url)
      .then(async (response) => {
        const res = await response.data;
        dispatch({
          type: GET_FAMILIA_PLANTAS_RESPONSE,
          get_familia: res,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_FAMILIA_PLANTAS_FAILURE,
        });
      });
  };
}


//-------------- nuevo -------------------
export const GET_FAMILIA_PLANTAS_NEW_REQUEST = "GET_FAMILIA_PLANTAS_NEW_REQUEST";
export const GET_FAMILIA_PLANTAS_NEW_RESPONSE = "GET_FAMILIA_PLANTAS_NEW_RESPONSE";
export const GET_FAMILIA_PLANTAS_NEW_FAILURE = "GET_FAMILIA_PLANTAS_NEW_FAILURE";

export function getFamiliaPlantasNew() {
  let url = rutas.get_familia_produccion;
  return (dispatch) => {
    dispatch({
      type: GET_FAMILIA_PLANTAS_NEW_REQUEST,
    });
    return axios
      .get(url)
      .then(async (response) => {
        const res = await response.data;
        // console.log(res);
        dispatch({
          type: GET_FAMILIA_PLANTAS_NEW_RESPONSE,
          get_familia_produccion: res,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_FAMILIA_PLANTAS_NEW_FAILURE,
        });
      });
  };
}


export const GET_DATA_GRAPHIC_HOME_REQUEST = "GET_DATA_GRAPHIC_HOME_REQUEST";
export const GET_DATA_GRAPHIC_HOME_RESPONSE = "GET_DATA_GRAPHIC_HOME_RESPONSE";
export const GET_DATA_GRAPHIC_HOME_FAILURE = "GET_DATA_GRAPHIC_HOME_FAILURE";

export function get_data_graphic_home(date, usuario) {
  let url = `${rutas.get_graphic_unic_home}?date=${date}&usuario=${usuario}`;

  return (dispatch) => {
    dispatch({
      type: GET_DATA_GRAPHIC_HOME_REQUEST,
    });
    return axios
      .get(url)
      .then(async (response) => {
        const res = await response.data;
        dispatch({
          type: GET_DATA_GRAPHIC_HOME_RESPONSE,
          data_graphic: res,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_DATA_GRAPHIC_HOME_FAILURE,
        });
      });
  };
}

export const GET_OCUPACION_PATIOS_INICIAL_REQUEST =
  "GET_OCUPACION_PATIOS_INICIAL_REQUEST";
export const GET_OCUPACION_PATIOS_INICIAL_RESPONSE =
  "GET_OCUPACION_PATIOS_INICIAL_RESPONSE";
export const GET_OCUPACION_PATIOS_INICIAL_FAILURE =
  "GET_OCUPACION_PATIOS_INICIAL_FAILURE";

export function get_ocupacion_patios_inicial() {
  let url = `${rutas.get_ocupacion_patios_inicial}`;
  return (dispatch) => {
    dispatch({
      type: GET_OCUPACION_PATIOS_INICIAL_REQUEST,
    });
    return axios
      .get(url)
      .then(async (response) => {
        const res = await response.data;
        dispatch({
          type: GET_OCUPACION_PATIOS_INICIAL_RESPONSE,
          data_ocuPatIni: res,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_OCUPACION_PATIOS_INICIAL_FAILURE,
        });
      });
  };
}

export const GET_OCUPACION_PATIOS_FILTER_REQUEST =
  "GET_OCUPACION_PATIOS_FILTER_REQUEST";
export const GET_OCUPACION_PATIOS_FILTER_RESPONSE =
  "GET_OCUPACION_PATIOS_FILTER_RESPONSE";
export const GET_OCUPACION_PATIOS_FILTER_FAILURE =
  "GET_OCUPACION_PATIOS_FILTER_FAILURE";

export function get_ocupacion_patios_filter(date) {
  let url = `${rutas.get_ocupacion_de_patios_filter}?date=${date}`;
  return (dispatch) => {
    dispatch({
      type: GET_OCUPACION_PATIOS_FILTER_REQUEST,
    });
    return axios
      .get(url)
      .then(async (response) => {
        const res = await response.data;
        dispatch({
          type: GET_OCUPACION_PATIOS_FILTER_RESPONSE,
          data_ocuPatFilter: res,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_OCUPACION_PATIOS_FILTER_FAILURE,
        });
      });
  };
}

export const GET_OCUPACION_DETALLE_REQUEST = "GET_OCUPACION_DETALLE_REQUEST";
export const GET_OCUPACION_DETALLE_RESPONSE = "GET_OCUPACION_DETALLE_RESPONSE";
export const GET_OCUPACION_DETALLE_FAILURE = "GET_OCUPACION_DETALLE_FAILURE";

export function get_ocupacion_excel_detalle(date) {
  let url = `${rutas.get_ocupacion_patios_excel_detalle}?date=${date}`;
  return (dispatch) => {
    dispatch({
      type: GET_OCUPACION_DETALLE_REQUEST,
    });
    return axios
      .get(url)
      .then(async (response) => {
        const res = await response.data;
        dispatch({
          type: GET_OCUPACION_DETALLE_RESPONSE,
          data_ocupacion_detalle: res,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_OCUPACION_DETALLE_FAILURE,
        });
      });
  };
}

export const GET_BLOQUERAS_ANTERIOR_REQUEST = "GET_BLOQUERAS_ANTERIOR_REQUEST";
export const GET_BLOQUERAS_ANTERIOR_RESPONSE =
  "GET_BLOQUERAS_ANTERIOR_RESPONSE";
export const GET_BLOQUERAS_ANTERIOR_FAILURE = "GET_BLOQUERAS_ANTERIOR_FAILURE";

export function get_bloqueras_anterior(date) {
  let url = `${rutas.get_produccion_Ant_Bloqueras}?date=${date}`;
  return (dispatch) => {
    dispatch({
      type: GET_BLOQUERAS_ANTERIOR_REQUEST,
    });
    return axios
      .get(url)
      .then(async (response) => {
        const res = await response.data;
        dispatch({
          type: GET_BLOQUERAS_ANTERIOR_RESPONSE,
          data_bloq_anterior: res,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_BLOQUERAS_ANTERIOR_FAILURE,
        });
      });
  };
}

export const GET_TUBOS_ANTERIOR_REQUEST = "GET_TUBOS_ANTERIOR_REQUEST";
export const GET_TUBOS_ANTERIOR_RESPONSE = "GET_TUBOS_ANTERIOR_RESPONSE";
export const GET_TUBOS_ANTERIOR_FAILURE = "GET_TUBOS_ANTERIOR_FAILURE";

export function get_tubos_anterior(date) {
  let url = `${rutas.get_produccion_Ant_tubos}?date=${date}`;
  return (dispatch) => {
    dispatch({
      type: GET_TUBOS_ANTERIOR_REQUEST,
    });
    return axios
      .get(url)
      .then(async (response) => {
        const res = await response.data;
        dispatch({
          type: GET_TUBOS_ANTERIOR_RESPONSE,
          data_tubos_anterior: res,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_TUBOS_ANTERIOR_FAILURE,
        });
      });
  };
}

export const GET_AGREGADOS_ANTERIOR_REQUEST = "GET_AGREGADOS_ANTERIOR_REQUEST";
export const GET_AGREGADOS_ANTERIOR_RESPONSE =
  "GET_AGREGADOS_ANTERIOR_RESPONSE";
export const GET_AGREGADOS_ANTERIOR_FAILURE = "GET_AGREGADOS_ANTERIOR_FAILURE";

export function get_agregados_anterior(date) {
  let url = `${rutas.get_produccion_Ant_Agregados}?date=${date}`;
  return (dispatch) => {
    dispatch({
      type: GET_AGREGADOS_ANTERIOR_REQUEST,
    });
    return axios
      .get(url)
      .then(async (response) => {
        const res = await response.data;
        dispatch({
          type: GET_AGREGADOS_ANTERIOR_RESPONSE,
          data_agregados_anterior: res,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_AGREGADOS_ANTERIOR_FAILURE,
        });
      });
  };
}

//------------view produccion----------

export const GET_PRODUCCION_REQUEST = "GET_PRODUCCION_REQUEST";
export const GET_PRODUCCION_RESPONSE = "GET_PRODUCCION_RESPONSE";
export const GET_PRODUCCION_FAILURE = "GET_PRODUCCION_FAILURE";

export function get_produccion(periodo, mes, planta) {
  let url = `${rutas.get_produccion}?periodo=${periodo}&mes=${mes}&planta=${planta}`;
  return (dispatch) => {
    dispatch({
      type: GET_PRODUCCION_REQUEST,
    });
    return axios
      .get(url)
      .then(async (response) => {
        const res = await response.data;
        dispatch({
          type: GET_PRODUCCION_RESPONSE,
          produccion: res,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_PRODUCCION_FAILURE,
        });
      });
  };
}

export const GET_PRODUCCION_GRAPHIC_REQUEST = "GET_PRODUCCION_GRAPHIC_REQUEST";
export const GET_PRODUCCION_GRAPHIC_RESPONSE =
  "GET_PRODUCCION_GRAPHIC_RESPONSE";
export const GET_PRODUCCION_GRAPHIC_FAILURE = "GET_PRODUCCION_GRAPHIC_FAILURE";

export function get_produccion_graphic(periodo, mes, planta) {
  let url = `${rutas.get_produccion_graphic}?periodo=${periodo}&mes=${mes}&planta=${planta}`;
  // console.log(url);
  return (dispatch) => {
    dispatch({
      type: GET_PRODUCCION_GRAPHIC_REQUEST,
    });
    return axios
      .get(url)
      .then(async (response) => {
        const res = await response.data;
        dispatch({
          type: GET_PRODUCCION_GRAPHIC_RESPONSE,
          produccion_graphic: res,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_PRODUCCION_GRAPHIC_FAILURE,
        });
      });
  };
}

export const GET_EXISTENCIA_ACTUAL_REQUEST = "GET_EXISTENCIA_ACTUAL_REQUEST";
export const GET_EXISTENCIA_ACTUAL_RESPONSE = "GET_EXISTENCIA_ACTUAL_RESPONSE";
export const GET_EXISTENCIA_ACTUAL_FAILURE = "GET_EXISTENCIA_ACTUAL_FAILURE";

export function get_existencia_actual(date, planta) {
  let url = `${rutas.get_existencia_actual}?date=${date}&planta=${planta}`;
  return (dispatch) => {
    dispatch({
      type: GET_EXISTENCIA_ACTUAL_REQUEST,
    });
    return axios
      .get(url)
      .then(async (response) => {
        const res = await response.data;
        dispatch({
          type: GET_EXISTENCIA_ACTUAL_RESPONSE,
          existencia_A: res,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_EXISTENCIA_ACTUAL_FAILURE,
        });
      });
  };
}

export const GET_DESPACHOS_DIARIOS_GRAPHIC_REQUEST =
  "GET_DESPACHOS_DIARIOS_GRAPHIC_REQUEST";
export const GET_DESPACHOS_DIARIOS_GRAPHIC_RESPONSE =
  "GET_DESPACHOS_DIARIOS_GRAPHIC_RESPONSE";
export const GET_DESPACHOS_DIARIOS_GRAPHIC_FAILURE =
  "GET_DESPACHOS_DIARIOS_GRAPHIC_FAILURE";

export function get_despachos_diarios_graphic(
  Year,
  is_description,
  planta,
  is_article
) {
  let url = `${rutas.get_despachos_diarios_graphic}?year=${Year}&month=${is_description}&planta=${planta}&articulo=${is_article}`;
  return (dispatch) => {
    dispatch({
      type: GET_DESPACHOS_DIARIOS_GRAPHIC_REQUEST,
    });
    return axios
      .get(url)
      .then(async (response) => {
        const res = await response.data;
        console.log(res);
        dispatch({
          type: GET_DESPACHOS_DIARIOS_GRAPHIC_RESPONSE,
          despachos_diarios_g: res,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_DESPACHOS_DIARIOS_GRAPHIC_FAILURE,
        });
      });
  };
}

export const GET_DESPACHOS_DIARIOS_TABLE_REQUEST =
  "GET_DESPACHOS_DIARIOS_TABLE_REQUEST";
export const GET_DESPACHOS_DIARIOS_TABLE_RESPONSE =
  "GET_DESPACHOS_DIARIOS_TABLE_RESPONSE";
export const GET_DESPACHOS_DIARIOS_TABLE_FAILURE =
  "GET_DESPACHOS_DIARIOS_TABLE_FAILURE";

export function get_despachos_diarios_table(
  Year,
  is_description,
  planta,
  is_article
) {
  let url = `${rutas.get_despachos_diarios_table}?year=${Year}&month=${is_description}&planta=${planta}&articulo=${is_article}`;
  return (dispatch) => {
    dispatch({
      type: GET_DESPACHOS_DIARIOS_TABLE_REQUEST,
    });
    return axios
      .get(url)
      .then(async (response) => {
        const res = await response.data;
        dispatch({
          type: GET_DESPACHOS_DIARIOS_TABLE_RESPONSE,
          despachos_diarios_t: res,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_DESPACHOS_DIARIOS_TABLE_FAILURE,
        });
      });
  };
}

export const GET_DESPACHOS_DIARIOS_DETALLADO_REQUEST =
  "GET_DESPACHOS_DIARIOS_DETALLADO_REQUEST";
export const GET_DESPACHOS_DIARIOS_DETALLADO_RESPONSE =
  "GET_DESPACHOS_DIARIOS_DETALLADO_RESPONSE";
export const GET_DESPACHOS_DIARIOS_DETALLADO_FAILURE =
  "GET_DESPACHOS_DIARIOS_DETALLADO_FAILURE";

export function get_despachos_diarios_detallado(Year, mes, planta) {
  let url = `${rutas.get_despachos_diarios_detallado}?year=${Year}&month=${mes}&planta=${planta}`;
  return (dispatch) => {
    dispatch({
      type: GET_DESPACHOS_DIARIOS_DETALLADO_REQUEST,
    });
    return axios
      .get(url)
      .then(async (response) => {
        const res = await response.data;
        dispatch({
          type: GET_DESPACHOS_DIARIOS_DETALLADO_RESPONSE,
          despachos_diarios_d: res,
        });
      })
      .catch((error) => {
        console.log(error);
        dispatch({
          type: GET_DESPACHOS_DIARIOS_DETALLADO_FAILURE,
        });
      });
  };
}
